import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from '@angular/common';

@Component({
  selector: "app-subpage",
  templateUrl: "./subpage.component.html",
  styleUrls: ["./subpage.component.scss"],
})
export class SubpageComponent implements OnInit {
  constructor(private router: Router, private locations: Location) {}
  selectedtab = 1;
  countryCode = "US";
  ngOnInit() {
    setTimeout(() => {
      this.locations.replaceState("/Overview");
    }, 800);

    if(localStorage.getItem("countryCode")){
      this.countryCode = localStorage.getItem("countryCode");
    }
    console.log(this.countryCode);
    
  }

  goToLogin() {
    this.router.navigate(["/login"]);
  }

  onSelect(data): void {
    if(data.heading === 'Overview'){
      setTimeout(() => {
        this.locations.replaceState("/Overview");
      }, 1000);
    }else if(data.heading === 'How it Works'){
      setTimeout(() => {
        this.locations.replaceState("/howitworks");
      }, 1000);
    }else if(data.heading === 'Benefits'){
      setTimeout(() => {
        this.locations.replaceState("/benefits");
      }, 1000);
    }else if(data.heading === 'Costs'){
      setTimeout(() => {
        this.locations.replaceState("/costs");
      }, 1000);
    }else if(data.heading === 'Start Now'){
      setTimeout(() => {
        this.locations.replaceState("/startnow");
      }, 1000);
    }
  }

  submitform() {}
}
